import { Badge } from '@chakra-ui/react';
import { memo } from 'react';

import { SUPPLIER_PAYOUT_STATUS_META } from '@features/finance/financeMeta';
import type { SupplierPayoutStatus } from 'helpers/fakeData';

interface Props {
  status: SupplierPayoutStatus;
}

const SupplierPayoutStatusBadge = memo(({ status }: Props) => {
  const meta = SUPPLIER_PAYOUT_STATUS_META[status];
  return (
    <Badge size="xs" colorPalette={meta.palette} variant="subtle" borderRadius="full">
      {meta.label}
    </Badge>
  );
});
SupplierPayoutStatusBadge.displayName = 'SupplierPayoutStatusBadge';

export default SupplierPayoutStatusBadge;
